var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlyFans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 33,
    viewBox: "0 0 54 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s31ehzq8ha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.083.616a15.79 15.79 0 0 1 11.194 4.65 15.875 15.875 0 0 1 3.432 5.15 15.917 15.917 0 0 1 1.206 6.076c0 6.421-3.858 12.21-9.773 14.667a15.799 15.799 0 0 1-17.253-3.441 15.91 15.91 0 0 1-3.432-17.301 15.831 15.831 0 0 1 14.626-9.8zm0 20.638a4.742 4.742 0 0 0 4.39-2.939c.238-.578.36-1.198.36-1.823a4.763 4.763 0 0 0-2.932-4.4 4.74 4.74 0 0 0-5.175 1.032 4.773 4.773 0 0 0-1.03 5.19 4.75 4.75 0 0 0 4.388 2.94z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.878 12.523c4.023 1.16 8.77 0 8.77 0-1.377 6.033-5.747 9.811-12.048 10.271a15.85 15.85 0 0 1-5.828 6.968 15.787 15.787 0 0 1-8.688 2.605l4.75-15.137C28.716 1.67 31.218.617 42.797.617h7.95c-1.33 5.874-5.914 10.36-13.868 11.906z",
    fill: "#008CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s31ehzq8ha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .492)",
    d: "M0 0h54v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyFans);
export default __webpack_public_path__ + "static/media/only-fans.fdfbb2133fc66d6df4b7a6dcbfc23d1c.svg";
export { ForwardRef as ReactComponent };